export default __webpack_public_path__ + "static/media/mark1.92c3561e.png";